import { RichTextNodeType } from 'types/RichTextContent';
import Text from './Text';
import Hyperlink from './Hyperlink';
import Paragraph from './Paragraph';
import Heading1 from './Heading1';
import Heading2 from './Heading2';
import Heading3 from './Heading3';
import Heading4 from './Heading4';
import Heading5 from './Heading5';
import Heading6 from './Heading6';
import UnorderedList from './UnorderedList';
import OrderedList from './OrderedList';
import ListItem from './ListItem';
import EmbeddedAssetBlock from './EmbeddedAssetBlock';
import EntryHyperlink from './EntryHyperlink';

export const getComponentForNodeType = (nodeType: RichTextNodeType) => {
  switch (nodeType) {
    case 'text':
      return Text;
    case 'hyperlink':
      return Hyperlink;
    case 'heading-1':
      return Heading1;
    case 'heading-2':
      return Heading2;
    case 'heading-3':
      return Heading3;
    case 'heading-4':
      return Heading4;
    case 'heading-5':
      return Heading5;
    case 'heading-6':
      return Heading6;
    case 'paragraph':
      return Paragraph;
    case 'unordered-list':
      return UnorderedList;
    case 'ordered-list':
      return OrderedList;
    case 'list-item':
      return ListItem;
    case 'embedded-asset-block':
      return EmbeddedAssetBlock;
    case 'entry-hyperlink':
      return EntryHyperlink;
    default: {
      console.warn(`Unhandled node type ${nodeType}`);
      return null;
    }
  }
};
